import { AssetsFilterWidget } from "../FiltersWidgets/AssetsFilterWidget";
import { BathRoomFilterWidget } from "../FiltersWidgets/BathroomFilterWidget";
import { BudgetsFilterWidget } from "../FiltersWidgets/BudgetsFilterWidget";
import { CamerasFilterWidget } from "../FiltersWidgets/CamerasFilterWidget";
import { CoatingsFilterWiget } from "../FiltersWidgets/CoatingsFilterWidget";
import { GroupsFilterWidget } from "../FiltersWidgets/GroupsFilterWidget";
import { HideFiltersFilterWidget } from "../FiltersWidgets/HideFiltersFilterWidget";
import { KitchenFilterWidget } from "../FiltersWidgets/KitchenFilterWidget";
import { LightsFilterWidget } from "../FiltersWidgets/LightsFilterWidget";
import { MagicSearchFilterWidget } from "../FiltersWidgets/MagicSearchFilterWidget";
import { PinBoardsFilterWidget } from "../FiltersWidgets/PinBoardsFilterWidget";
import { StorageFilterWidget } from "../FiltersWidgets/StorageFilterWidget";
import { StyleFilterWidget } from "../FiltersWidgets/StyleFilterWidget";
import { FilterGroup } from "./FilterGroup";

export class WidgetFactory {

    /**
     * Creates a widget based on the provided type, container and options.
     * @param type The type of the widget to create (AKA the id of the widget).
     * @param container The HTML element to attach the widget to.
     * @param options An object/dictionary where each key represents an array name and each value is an array required by the widget.
     * @returns An instance of the created widget typed as {@link FilterGroup}.
     */
    static createWidget(type: string, container: string, options?: any): FilterGroup {
        switch (type) {
            case 'assets':
                return new AssetsFilterWidget(container);
            case 'bathroom':
                return new BathRoomFilterWidget(container, options.bathroomElements);
            case 'budgets':
                return new BudgetsFilterWidget(container);
            case 'cameras':
                return new CamerasFilterWidget(container);
            case 'coatings':
                return new CoatingsFilterWiget(container);
            case 'groups':
                return new GroupsFilterWidget(container);
            case 'hideFilters':
                return new HideFiltersFilterWidget(container);
            case 'kitchen':
                return new KitchenFilterWidget(container, options.kitchenElements);
            case 'lights':
                return new LightsFilterWidget(container);
            case 'magicsearch':
                return new MagicSearchFilterWidget(container);
            case 'pinboards':
                return new PinBoardsFilterWidget(container);
            case 'storage':
                return new StorageFilterWidget(container, options.storageElementsDepth,
                    options.storageElementsHeight, options.storageElementsType);
            case 'style':
                return new StyleFilterWidget(container);
            default:
                throw new Error(`Unknown widget type: ${type}`);
        }
    }
}